export type CopyResult='copied'|'manual';
export type OpenResult='opened'|'manual';
export type ShareResult='shared'|'copied'|'manual';
export type RuntimeChannel='web'|'toss'|'ios'|'android';
type NativeBridge={isNativePlatform?:()=>boolean;getPlatform?:()=>string};
const nativeBridge=()=>(globalThis as typeof globalThis&{Capacitor?:NativeBridge}).Capacitor;

export const isTossRuntime=()=>import.meta.env.MODE==='toss';
export const isNativeRuntime=()=>nativeBridge()?.isNativePlatform?.()===true;
export const runtimeChannel=():RuntimeChannel=>isTossRuntime()?'toss':nativeBridge()?.getPlatform?.()==='ios'?'ios':nativeBridge()?.getPlatform?.()==='android'?'android':'web';
export const isEmbeddedRuntime=()=>isTossRuntime()||isNativeRuntime();
export const publicShareOrigin=()=>isEmbeddedRuntime()?'https://seonmulgam.com':location.origin;

export async function copyText(value:string):Promise<CopyResult>{
  try{if(isNativeRuntime()){const{Clipboard}=await import('@capacitor/clipboard');await Clipboard.write({string:value});return'copied'}if(navigator.clipboard?.writeText){await navigator.clipboard.writeText(value);return'copied'}}catch{/* Continue to the visible manual fallback. */}
  const field=document.createElement('textarea');field.value=value;field.setAttribute('readonly','');field.style.cssText='position:fixed;opacity:0;pointer-events:none';document.body.append(field);field.select();const copied=typeof document.execCommand==='function'&&document.execCommand('copy');field.remove();return copied?'copied':'manual';
}

export async function openExternal(url:string):Promise<OpenResult>{
  try{
    if(isTossRuntime()){const{openURL}=await import('@apps-in-toss/web-framework');await openURL(url);return'opened'}
    if(isNativeRuntime()){const{Browser}=await import('@capacitor/browser');await Browser.open({url,presentationStyle:'popover'});return'opened'}
    const opened=window.open(url,'_blank','noopener,noreferrer');if(opened)return'opened';
  }catch{/* Use the manual-copy recovery in the caller. */}
  return'manual';
}

export async function shareText(message:string):Promise<ShareResult>{
  try{
    if(isTossRuntime()){const{share}=await import('@apps-in-toss/web-framework');await share({message});return'shared'}
    if(isNativeRuntime()){const{Share}=await import('@capacitor/share');await Share.share({text:message,dialogTitle:'선물감 공유'});return'shared'}
    if(navigator.share){await navigator.share({text:message});return'shared'}
  }catch{/* A cancelled or unavailable share sheet falls back to copy. */}
  const copied=await copyText(message);return copied==='copied'?'copied':'manual';
}

export async function saveFile(blob:Blob,fileName:string):Promise<'opened'|'unavailable'>{
 try{
  if(isTossRuntime()){
   const{saveBase64Data}=await import('@apps-in-toss/web-framework');
   if(!saveBase64Data.isSupported())return'unavailable';
   const data=await new Promise<string>((resolve,reject)=>{const reader=new FileReader();reader.onerror=()=>reject(reader.error);reader.onload=()=>resolve(String(reader.result).split(',')[1]??'');reader.readAsDataURL(blob)});
   if(!data)return'unavailable';
   await saveBase64Data({data,fileName,mimeType:blob.type.split(';')[0]||'application/octet-stream'});return'opened';
  }
  const url=URL.createObjectURL(blob);const anchor=document.createElement('a');anchor.href=url;anchor.download=fileName;anchor.click();setTimeout(()=>URL.revokeObjectURL(url),0);return'opened';
 }catch{return'unavailable'}
}

export async function personRecordLink(personId:string):Promise<string|undefined>{
 if(isTossRuntime()){try{const{getTossShareLink}=await import('@apps-in-toss/web-framework');return await getTossShareLink(`intoss://seonmulgam/person?id=${encodeURIComponent(personId)}`)}catch{return undefined}}
 return `https://seonmulgam.com/person?id=${encodeURIComponent(personId)}`;
}
